/* eslint-disable no-param-reassign */
import Fetch, { V1, V2, V3 } from 'Util/fetcher';

//= =========================================//
//              GET PORTFOLIO STOCK         //
//= =========================================//

const ON_GET_PORTFOLIO_STOCK = 'ON_GET_PORTFOLIO_STOCK';
const ON_GET_PORTFOLIO_STOCK_SUCCESS = 'ON_GET_PORTFOLIO_STOCK_SUCCESS';
const ON_GET_PORTFOLIO_STOCK_FAILURE = 'ON_GET_PORTFOLIO_STOCK_FAILURE';

function onGetPortfolioStock() {
  return {
    type: ON_GET_PORTFOLIO_STOCK,
  };
}

function onGetPortfolioStockSuccess(payload) {
  return {
    type: ON_GET_PORTFOLIO_STOCK_SUCCESS,
    payload,
  };
}

function onGetPortfolioStockFailure(payload) {
  return {
    type: ON_GET_PORTFOLIO_STOCK_FAILURE,
    payload,
  };
}

export const onDoGetPortfolioStock = () => (dispatch) => {
  dispatch(onGetPortfolioStock());
  Fetch.get(`${V3}stock/portfolio/`)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onGetPortfolioStockSuccess(resp.json?.result));
      } else {
        dispatch(onGetPortfolioStockFailure(resp.json?.result));
      }
    })
    .catch((error) => {
      dispatch(onGetPortfolioStockFailure(error.message));
    });
};

//= ==========================================//
//          GET PORTFOLIO DETAIL             //
//= ==========================================//

const ON_REQUEST_PORTOFOLIO_DETAIL = 'ON_REQUEST_PORTOFOLIO_DETAIL';
const ON_REQUEST_PORTOFOLIO_DETAIL_FAILURE = 'ON_REQUEST_PORTOFOLIO_DETAIL_FAILURE';
const ON_REQUEST_PORTOFOLIO_DETAIL_SUCCESS = 'ON_REQUEST_PORTOFOLIO_DETAIL_SUCCESS';

function onRequestPortoDetail() {
  return {
    type: ON_REQUEST_PORTOFOLIO_DETAIL,
  };
}

function onRequestPortoDetailSuccess(payload) {
  return {
    type: ON_REQUEST_PORTOFOLIO_DETAIL_SUCCESS,
    payload,
  };
}

function onRequestPortoDetailFailure(payload) {
  return {
    type: ON_REQUEST_PORTOFOLIO_DETAIL_FAILURE,
    payload,
  };
}

export const onDoRequestPortoDetail = payload => (dispatch) => {
  dispatch(onRequestPortoDetail());
  Fetch.get(`${V3}stock/portfoliodetail/?ticker_code=${payload}`)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRequestPortoDetailSuccess(resp.json?.result));
      } else {
        dispatch(onRequestPortoDetailFailure(resp.json?.result));
      }
    })
    .catch((error) => {
      dispatch(onRequestPortoDetailFailure(error.message));
    });
};

//= ==========================================//
//          GET PORTFOLIO DETAIL             //
//= ==========================================//

const ON_GET_AUTO_INVEST = 'ON_GET_AUTO_INVEST';
const ON_GET_AUTO_INVEST_SUCCESS = 'ON_GET_AUTO_INVEST_SUCCESS';
const ON_GET_AUTO_INVEST_FAILURE = 'ON_GET_AUTO_INVEST_FAILURE';

function onGetAutoInvest() {
  return {
    type: ON_GET_AUTO_INVEST,
  };
}

function onGetAutoInvestSuccess(payload) {
  return {
    type: ON_GET_AUTO_INVEST_SUCCESS,
    payload,
  };
}

function onGetAutoInvestFailure(payload) {
  return {
    type: ON_GET_AUTO_INVEST_FAILURE,
    payload,
  };
}

export const onDoGetAutoInvest = () => (dispatch) => {
  dispatch(onGetAutoInvest());
  Fetch.get(`${V2}ajaibconf/invest/summary/`)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onGetAutoInvestSuccess(resp.json));
      } else {
        dispatch(onGetAutoInvestFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onGetAutoInvestFailure(error.message));
    });
};

//= ==========================================//
//          GET HISTORY TRANSACTION          //
//= ==========================================//

const ON_GET_HISTORY_BY_CODE = 'ON_GET_HISTORY_BY_CODE';
const ON_GET_HISTORY_BY_CODE_SUCCESS = 'ON_GET_HISTORY_BY_CODE_SUCCESS';
const ON_GET_HISTORY_BY_CODE_FAILURE = 'ON_GET_HISTORY_BY_CODE_FAILURE';

function onGetHistoryByCode(resetData) {
  return {
    type: ON_GET_HISTORY_BY_CODE,
    meta: { resetData },
  };
}

function onGetHistoryByCodeSuccess(payload) {
  return {
    type: ON_GET_HISTORY_BY_CODE_SUCCESS,
    payload,
  };
}

function onGetHistoryByCodeFailure(payload) {
  return {
    type: ON_GET_HISTORY_BY_CODE_FAILURE,
    payload,
  };
}

export const onDoGetHistoryByCode = (payload, resetData = false) => (
  dispatch
) => {
  dispatch(onGetHistoryByCode(resetData));
  Fetch.get(`${V1}stock/historytrade-filter/${payload}`)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onGetHistoryByCodeSuccess(resp.json));
      } else {
        dispatch(onGetHistoryByCodeFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onGetHistoryByCodeFailure(error.message));
    });
};

//= ==========================================//
//           GET OPEN TRANSACTION            //
//= ==========================================//

const ON_GET_TRANSACTION_BY_CODE = 'ON_GET_TRANSACTION_BY_CODE';
const ON_GET_TRANSACTION_BY_CODE_SUCCESS = 'ON_GET_TRANSACTION_BY_CODE_SUCCESS';
const ON_GET_TRANSACTION_BY_CODE_FAILURE = 'ON_GET_TRANSACTION_BY_CODE_FAILURE';

function onGetTransactionByCode(resetData) {
  return {
    type: ON_GET_TRANSACTION_BY_CODE,
    meta: { resetData },
  };
}

function onGetTransactionByCodeSuccess(payload) {
  return {
    type: ON_GET_TRANSACTION_BY_CODE_SUCCESS,
    payload,
  };
}

function onGetTransactionByCodeFailure(payload) {
  return {
    type: ON_GET_TRANSACTION_BY_CODE_FAILURE,
    payload,
  };
}

export const onDoGetTransactionByCode = (payload, resetData = false) => (
  dispatch
) => {
  dispatch(onGetTransactionByCode(resetData));
  Fetch.get(`${V1}stock/orderlist-filter/${payload}`)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onGetTransactionByCodeSuccess(resp.json));
      } else {
        dispatch(onGetTransactionByCodeFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onGetTransactionByCodeFailure(error.message));
    });
};

//= ==========================================//
//            GET THEME PORTFOLIO            //
//= ==========================================//

const ON_GET_PORTFOLIO_THEME = 'ON_GET_PORTFOLIO_THEME';
const ON_GET_PORTFOLIO_THEME_SUCCESS = 'ON_GET_PORTFOLIO_THEME_SUCCESS';
const ON_GET_PORTFOLIO_THEME_FAILURE = 'ON_GET_PORTFOLIO_THEME_FAILURE';

function onGetPortfolioTheme() {
  return {
    type: ON_GET_PORTFOLIO_THEME,
  };
}

function onGetPortfolioThemeSuccess(payload) {
  return {
    type: ON_GET_PORTFOLIO_THEME_SUCCESS,
    payload,
  };
}

function onGetPortfolioThemeFailure(payload) {
  return {
    type: ON_GET_PORTFOLIO_THEME_FAILURE,
    payload,
  };
}

export const onDoGetPortfolioTheme = () => (dispatch) => {
  dispatch(onGetPortfolioTheme());
  Fetch.get(`${V3}users/theme-funds/`)
    .then((resp) => {
      dispatch(onGetPortfolioThemeSuccess(resp.json));
    })
    .catch((error) => {
      dispatch(onGetPortfolioThemeFailure(error.message));
    });
};

//= ==========================================//
//          GET HISTORY TRANSACTION THEME    //
//= ==========================================//

const ON_GET_TRANSACTION_BY_ID = 'ON_GET_TRANSACTION_BY_ID';
const ON_GET_TRANSACTION_BY_ID_SUCCESS = 'ON_GET_TRANSACTION_BY_ID_SUCCESS';
const ON_GET_TRANSACTION_BY_ID_FAILURE = 'ON_GET_TRANSACTION_BY_ID_FAILURE';

function onGetTransactionById(resetData) {
  return {
    type: ON_GET_TRANSACTION_BY_ID,
    meta: { resetData },
  };
}

function onGetTransactionByIdSuccess(payload) {
  return {
    type: ON_GET_TRANSACTION_BY_ID_SUCCESS,
    payload,
  };
}

function onGetTransactionByIdFailure(payload) {
  return {
    type: ON_GET_TRANSACTION_BY_ID_FAILURE,
    payload,
  };
}

export const onDoGetTransactionById = payload => (dispatch) => {
  dispatch(onGetTransactionById());
  Fetch.get(`${V1}users/me/theme-fund/${payload}/history/`)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onGetTransactionByIdSuccess(resp.json));
      } else {
        dispatch(onGetTransactionByIdFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onGetTransactionByIdFailure(error.message));
    });
};

const INITIAL_STATE = {
  portfolioStockLoading: null,
  portfolioStockData: null,
  portfolioStockError: null,

  portoDetailData: null,
  portoDetailLoading: null,
  portoDetailError: null,

  autoInvestLoading: null,
  autoInvestData: null,
  autoInvestError: null,

  historyByCodeLoading: null,
  historyByCodeData: null,
  historyByCodeError: null,

  transactionByCodeLoading: null,
  transactionByCodeData: null,
  transactionByCodeError: null,

  portfolioThemeLoading: null,
  portfolioThemeData: null,
  portfolioThemeError: null,

  transactionByIdLoading: null,
  transactionByIdData: null,
  transactionByIdError: null,
};

const portfolio = (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case ON_GET_PORTFOLIO_STOCK:
      return {
        ...state,
        portfolioStockLoading: true,
        portfolioStockData: null || { ...state.portfolioStockData },
        portfolioStockError: null,
      };
    case ON_GET_PORTFOLIO_STOCK_SUCCESS:
      return {
        ...state,
        portfolioStockLoading: false,
        portfolioStockData: action.payload,
        portoDetailStockError: null,
      };
    case ON_GET_PORTFOLIO_STOCK_FAILURE:
      return {
        ...state,
        portfolioStockLoading: false,
        portfolioStockData: null || { ...state.portfolioStockData },
        portfolioStockError: action.payload,
      };
    case ON_REQUEST_PORTOFOLIO_DETAIL:
      return {
        ...state,
        portoDetailLoading: true,
        portoDetailData: null,
        portoDetailError: null,
      };
    case ON_REQUEST_PORTOFOLIO_DETAIL_SUCCESS:
      return {
        ...state,
        portoDetailLoading: false,
        portoDetailData: action.payload,
        portoDetailError: null,
      };
    case ON_REQUEST_PORTOFOLIO_DETAIL_FAILURE:
      return {
        ...state,
        portoDetailLoading: false,
        portoDetailData: null,
        portoDetailError: action.payload,
      };
    case ON_GET_AUTO_INVEST:
      return {
        ...state,
        autoInvestLoading: true,
        autoInvestData: null,
        autoInvestError: null,
      };
    case ON_GET_AUTO_INVEST_SUCCESS:
      return {
        ...state,
        autoInvestLoading: false,
        autoInvestData: action.payload,
        autoInvestError: null,
      };
    case ON_GET_AUTO_INVEST_FAILURE:
      return {
        ...state,
        autoInvestLoading: false,
        autoInvestData: null,
        autoInvestError: action.payload,
      };
    case ON_GET_TRANSACTION_BY_CODE:
      if (action.meta.resetData) {
        return {
          ...state,
          transactionByCodeLoading: true,
          transactionByCodeData: null,
          transactionByCodeError: null,
        };
      } 
        return {
          ...state,
          transactionByCodeLoading: true,
          transactionByCodeError: null,
        };
      
    case ON_GET_TRANSACTION_BY_CODE_SUCCESS:
      if (state.transactionByCodeData) {
        const oldResults = [...state.transactionByCodeData.result.results];
        state.transactionByCodeData = {
          ...action.payload,
          result: {
            count: action.payload.result.count,
            results: [...oldResults, ...action.payload.result.results],
          },
        };
      } else {
        state.transactionByCodeData = action.payload;
      }
      return {
        ...state,
        transactionByCodeLoading: false,
        transactionByCodeError: null,
      };

    case ON_GET_TRANSACTION_BY_CODE_FAILURE:
      return {
        ...state,
        transactionByCodeLoading: false,
        transactionByCodeError: action.payload,
      };
    case ON_GET_PORTFOLIO_THEME:
      return {
        ...state,
        portfolioThemeLoading: true,
        portfolioThemeData: null,
        portfolioThemeError: null,
      };
    case ON_GET_PORTFOLIO_THEME_SUCCESS:
      return {
        ...state,
        portfolioThemeLoading: false,
        portfolioThemeData: action.payload,
        portfolioThemeError: null,
      };

    case ON_GET_PORTFOLIO_THEME_FAILURE:
      return {
        ...state,
        portfolioThemeLoading: false,
        portfolioThemeData: null,
        portfolioThemeError: action.payload,
      };
    case ON_GET_TRANSACTION_BY_ID:
      return {
        ...state,
        transactionByIdLoading: true,
        transactionByIdData: null,
        transactionByIdError: null,
      };
    case ON_GET_TRANSACTION_BY_ID_SUCCESS:
      return {
        ...state,
        transactionByIdLoading: false,
        transactionByIdData: action.payload,
        transactionByIdError: null,
      };

    case ON_GET_TRANSACTION_BY_ID_FAILURE:
      return {
        ...state,
        transactionByIdLoading: false,
        transactionByIdData: null,
        transactionByIdError: action.payload,
      };

    case ON_GET_HISTORY_BY_CODE:
      if (action.meta.resetData) {
        return {
          ...state,
          historyByCodeLoading: true,
          historyByCodeData: null,
          historyByCodeError: null,
        };
      } 
        return {
          ...state,
          historyByCodeLoading: true,
          historyByCodeError: null,
        };
      
    case ON_GET_HISTORY_BY_CODE_SUCCESS:
      if (state.historyByCodeData) {
        const oldResults = [...state.historyByCodeData.result.results];
        state.historyByCodeData = {
          ...action.payload,
          result: {
            count: action.payload.result.count,
            results: [...oldResults, ...action.payload.result.results],
          },
        };
      } else {
        state.historyByCodeData = action.payload;
      }
      return {
        ...state,
        historyByCodeLoading: false,
        historyByCodeError: null,
      };

    case ON_GET_HISTORY_BY_CODE_FAILURE:
      return {
        ...state,
        historyByCodeLoading: false,
        historyByCodeError: action.payload,
      };
    default:
      return state;
  }
};

export default portfolio;
